export default __webpack_public_path__ + "static/media/Group1326.1a07f80f.svg";